var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EventEmitter } from "events";
import { API_TEST_TOKEN, default as defaultapi, } from "../api";
import { getAnnouncementItem, getAnnouncements } from "../api/announcement";
import { getDomainBlocklist, getDomainBlocklistItem } from "../api/blocklist";
import { getDMHistory, getDMPreview } from "../api/dm";
import { getBToCHistory, getBToCPreview } from "../api/b_to_c";
import { getEventsHistory } from "../api/events";
import { getDomainSettings, getUrlSettingItem, getUrlSettings, } from "../api/url";
import { checkIfTokenIsExpired, clearToken, clearTokenByToken, getCookieSignChallenge, getSavedToken, getSignChallenge, getUserUUIDFromStorage, saveToken, verifySignedChallenge, verifyCookieSignedChallenge, verifyCookieGuestChallenge, } from "../api/utils/token.utils";
import { createWhiteboard, getUnreadWhiteboardMessages, getHotRooms, getWhiteboardItem, getWhiteboardMessagesHistory, getWhiteboards, postWhiteBoardMessage, postWhiteBoardMessageReaction, postVoiceTranscribe, } from "../api/whiteboard";
import { log, SUPPORTED_ADAPTERS } from "../base";
import { addContactItem, deleteContactItem, getContactItem, getContacts, updateContactItem, getProfile, updateProfile, } from "../userprofile";
import { ProticoAuthCore } from "../core";
import { recordChatLevelEvent, recordHeartbeatEvent, recordLobbyOpenEvent, recordAdsEvent, recordTrendLobbyClickEvent, recordRewardsPageClickEvent, recordClickEvent, recordRecommendationEvent, recordNFTSentEvent, recordPageViewEvent, redeemProticoVoucher, rewardFetcher, voucherFetcher, } from "../api/engagement";
import { generateSessionId } from "../api/utils/session.utils";
export const PROTICO_API_EVENTS = {
    CLEAR_AUTH_TOKEN: "clear_auth_token",
};
export class ProticoClient extends EventEmitter {
    constructor(serverOrigin = "https://main.protico.io", analyticsURI = "https://analytics.protico.io/production/collect") {
        super();
        this.userInfo = null;
        this.sessionId = null;
        this.sessionStartTime = null;
        this.SESSION_EXPIRE_TIME = 1000 * 60 * 5; // 5 minutes
        this._setAuthToken = (token) => {
            this.api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        };
        this.setAuthToken = (token, domain) => __awaiter(this, void 0, void 0, function* () {
            this._setAuthToken(token);
            try {
                const userInfoRes = yield this.api.get(API_TEST_TOKEN, {
                    params: {
                        domain,
                        timestamp: Date.now(),
                    },
                });
                const userInfo = userInfoRes.data;
                this.userInfo = userInfo;
                if (userInfo.address && userInfo.auth_type == "googlelogin") {
                    ProticoAuthCore.prototype.connectTo(SUPPORTED_ADAPTERS.GOOGLE, userInfo.address);
                }
                return { success: true, userInfo };
            }
            catch (e) {
                this.clearAuthToken();
                this.userInfo = {
                    uuid: getUserUUIDFromStorage(),
                    address: null,
                    auth_type: "guest",
                    created_at: "",
                    updated_at: "",
                    real_address: null,
                    experience: 0,
                    moderators: [],
                };
                return { success: false, userInfo: this.userInfo };
            }
        });
        this.setRealAddressAuthToken = (token, domain) => __awaiter(this, void 0, void 0, function* () {
            this._setAuthToken(token);
            try {
                const userInfoRes = yield this.api.get(API_TEST_TOKEN, {
                    params: {
                        domain,
                        timestamp: Date.now(),
                    },
                });
                const userInfo = userInfoRes.data;
                this.userInfo = userInfo;
                if (userInfo.real_address && userInfo.auth_type == "googlelogin") {
                    ProticoAuthCore.prototype.connectTo(SUPPORTED_ADAPTERS.GOOGLE, userInfo.real_address);
                }
                return { success: true, userInfo };
            }
            catch (e) {
                this.clearAuthToken();
                this.userInfo = {
                    uuid: getUserUUIDFromStorage(),
                    address: null,
                    auth_type: "guest",
                    created_at: "",
                    updated_at: "",
                    real_address: null,
                    experience: 0,
                    moderators: [],
                };
                return { success: false, userInfo: this.userInfo };
            }
        });
        this.clearAuthToken = () => {
            delete this.api.defaults.headers.common["Authorization"];
        };
        this.blocklist = {
            get: (domain) => getDomainBlocklist(domain, this.api),
            getOne: (domain, address) => getDomainBlocklistItem(domain, address, this.api),
        };
        this.directMessages = {
            getPreview: (address) => getDMPreview(address, this.api),
            getHistory: (fromAddress, toAddress) => getDMHistory(fromAddress, toAddress, this.api),
        };
        this.bToCMessages = {
            getPreview: (address) => getBToCPreview(address, this.api),
            getHistory: (fromAddress, toDomain, referenceMessageId) => getBToCHistory(fromAddress, toDomain, this.api, referenceMessageId),
        };
        this.friends = {
            getEvents: (address) => getEventsHistory(address, this.api),
        };
        this.settings = {
            get: (domain) => getUrlSettings(domain, this.api),
            getOne: (urlSettingId) => getUrlSettingItem(urlSettingId, this.api),
            getDomainSettings: (domain) => getDomainSettings(domain, this.api),
        };
        this.whiteboard = {
            get: (domain, order) => getWhiteboards(this.api, { domain, order }),
            getOne: (id) => getWhiteboardItem(this.api, id),
            getMessages: (params) => getWhiteboardMessagesHistory(this.api, params),
            postMessage: (data, room, domain, roomUrl) => postWhiteBoardMessage(this.api, data, room, domain, roomUrl),
            getUnreadWhiteboardMessages: (room) => getUnreadWhiteboardMessages(this.api, room),
            getHotRooms: (room, domain) => getHotRooms(this.api, room, domain),
            create: (room, domain, roomUrl) => createWhiteboard(this.api, room, domain, roomUrl),
            postReaction: (data, room, msg_id) => postWhiteBoardMessageReaction(this.api, room, msg_id, data),
            postVoiceTranscribe: (audioBlob) => postVoiceTranscribe(this.api, audioBlob),
        };
        this.announcement = {
            get: (domain) => getAnnouncements(this.api, domain),
            getOne: (urlSettingId) => getAnnouncementItem(this.api, urlSettingId),
        };
        this.profile = {
            get: (address) => {
                return getProfile(this.api, address);
            },
            update: (newProfile) => {
                return updateProfile(this.api, newProfile);
            },
            // clear: () => {
            //   return clearProfile(this.api);
            // },
        };
        this.contact = {
            get: (address) => {
                return getContacts(this.api, address);
            },
            addOne: (address, newContact) => {
                return addContactItem(this.api, address, newContact);
            },
            getOne: (targetAddress) => {
                return getContactItem(this.api, targetAddress);
            },
            updateOne: (targetAddress, newContact) => {
                return updateContactItem(this.api, targetAddress, newContact);
            },
            deleteOne: (targetAddress) => {
                return deleteContactItem(this.api, targetAddress);
            },
        };
        this.engagement = {
            recordChatLevelEvent: (level) => {
                return recordChatLevelEvent(this.api, level, this.userInfo, {
                    sid: this.sessionId,
                });
            },
            recordNFTSentEvent: () => {
                return recordNFTSentEvent(this.api, this.userInfo, {
                    sid: this.sessionId,
                }, this._analyticsURI);
            },
            recordLobbyOpenEvent: (data) => {
                return recordLobbyOpenEvent(this.api, this.userInfo, Object.assign(Object.assign({}, data), { sid: this.sessionId }), this._analyticsURI);
            },
            recordAdsEvent: (data) => {
                return recordAdsEvent(this.api, this.userInfo, Object.assign(Object.assign({}, data), { sid: this.sessionId }), this._analyticsURI);
            },
            recordTrendLobbyClickEvent: (data) => {
                return recordTrendLobbyClickEvent(this.api, this.userInfo, Object.assign(Object.assign({}, data), { sid: this.sessionId }), this._analyticsURI);
            },
            recordRewardsPageClickEvent: (data) => {
                return recordRewardsPageClickEvent(this.api, this.userInfo, Object.assign(Object.assign({}, data), { sid: this.sessionId }), this._analyticsURI);
            },
            recordClickEvent: (data) => {
                return recordClickEvent(this.api, this.userInfo, Object.assign(Object.assign({}, data), { sid: this.sessionId }), this._analyticsURI);
            },
            recordRecommendationEvent: (data) => {
                return recordRecommendationEvent(this.api, this.userInfo, Object.assign(Object.assign({}, data), { sid: this.sessionId }), this._analyticsURI);
            },
            recordPageViewEvent: (data) => {
                return recordPageViewEvent(this.api, this.userInfo, Object.assign(Object.assign({}, data), { sid: this.sessionId }), this._analyticsURI);
            },
            recordHeartbeatEvent: () => {
                if (Date.now() - (this.sessionStartTime || 0) >
                    this.SESSION_EXPIRE_TIME) {
                    log.debug("Session expired, not recording heartbeat event");
                    return null;
                }
                return recordHeartbeatEvent(this.api, this.userInfo, {
                    sid: this.sessionId,
                }, this._analyticsURI);
            },
            getReward: (domain) => {
                return rewardFetcher(this.api, domain);
            },
            getVoucherList: () => {
                return voucherFetcher(this.api);
            },
            redeemVoucher: (data) => {
                return redeemProticoVoucher(this.api, data);
            },
        };
        this._analyticsURI = analyticsURI;
        this.sessionId = generateSessionId(16);
        this.sessionStartTime = Date.now();
        this.api = defaultapi.create({
            baseURL: serverOrigin,
        });
        this.api.defaults.headers.common["Protico-Agent"] = `Protico-Access-Token`;
        this.api.defaults.headers.common["Protico-Guest"] =
            getUserUUIDFromStorage();
        this.userInfo = {
            uuid: getUserUUIDFromStorage(),
            address: null,
            auth_type: "guest",
            created_at: "",
            updated_at: "",
            real_address: null,
            experience: 0,
            moderators: [],
        };
        this.api.interceptors.response.use((response) => response, (err) => {
            // Handle invalid token
            if (err.response &&
                err.response.status === 401 &&
                err.response.data &&
                err.response.data.code === "4011") {
                const token = this.api.defaults.headers.common["Authorization"].split(" ")[1];
                clearTokenByToken(token);
                this.clearAuthToken();
                this.emit(PROTICO_API_EVENTS.CLEAR_AUTH_TOKEN, {
                    message: "Invalid token",
                    token,
                });
            }
            log.error(`error in protico client: ${err}`);
            return Promise.reject(err);
        });
    }
    getWeb3AccessToken(proticoAuth) {
        return __awaiter(this, void 0, void 0, function* () {
            const account = yield proticoAuth.getConnectedAccount();
            const existingToken = yield this.checkTokenExpirationAndGetExisting(account, proticoAuth.connectedAdapterName);
            if (existingToken) {
                return { address: account, web3AccessToken: existingToken };
            }
            // Handle missing or expired token...
            const payload = {
                domain: window.location.origin,
                uri: window.location.href,
                address: account,
                version: "2",
                nonce: Math.random().toString(36).slice(2),
                issuedAt: new Date().toISOString(),
            };
            const challenge = yield getSignChallenge(payload, this.api);
            let signedMessage;
            try {
                signedMessage = (yield proticoAuth.provider.request({
                    method: "personal_sign",
                    params: [challenge, account],
                }));
            }
            catch (e) {
                throw Error("Error verifying signed challenge");
            }
            const web3AccessToken = yield verifySignedChallenge(signedMessage, challenge, proticoAuth.connectedAdapterName, 86400 * 30, this.api);
            saveToken(account, proticoAuth.connectedAdapterName, web3AccessToken);
            return {
                address: account,
                web3AccessToken: web3AccessToken.token,
            };
        });
    }
    getWeb3CookieSign(proticoAuth, domain, marketing_settings, functional_settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const account = yield proticoAuth.getConnectedAccount();
            // Handle missing or expired token...
            const payload = {
                domain: domain,
                address: account,
                nonce: Math.random().toString(36).slice(2),
                version: "1",
            };
            const challenge = yield getCookieSignChallenge(payload, this.api);
            let signedMessage;
            try {
                signedMessage = (yield proticoAuth.provider.request({
                    method: "personal_sign",
                    params: [challenge, account],
                }));
            }
            catch (e) {
                throw Error("Error verifying signed challenge");
            }
            const verifyCookieResponse = yield verifyCookieSignedChallenge(signedMessage, challenge, marketing_settings, functional_settings, proticoAuth.connectedAdapterName, account, domain, this.api);
            return {
                success: verifyCookieResponse.success,
            };
        });
    }
    getWeb3CookieGuestSign(domain, marketing_settings, functional_settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const verifyCookieResponse = yield verifyCookieGuestChallenge(marketing_settings, functional_settings, domain, this.api);
            return {
                success: verifyCookieResponse.success,
            };
        });
    }
    web3AccessTokenAutoStorage(proticoAuth) {
        return __awaiter(this, void 0, void 0, function* () {
            const account = yield proticoAuth.getConnectedAccount();
            const existingToken = yield this.checkTokenExpirationAndGetExisting(account, proticoAuth.connectedAdapterName);
            log.debug(`Existing token: ${existingToken}`);
            if (existingToken) {
                return { address: account, web3AccessToken: existingToken };
            }
            return null;
        });
    }
    checkTokenExpirationAndGetExisting(account, name) {
        return __awaiter(this, void 0, void 0, function* () {
            const existingToken = getSavedToken(account, name);
            if (existingToken) {
                const isExpired = checkIfTokenIsExpired(existingToken);
                if (!isExpired) {
                    return existingToken.token;
                }
                clearToken(account, name);
            }
            return null;
        });
    }
}
//# sourceMappingURL=index.js.map